import { createFileRoute, Link } from "@tanstack/react-router";
import { Quote } from "lucide-react";
import { Button, Section } from "@alight/ui";
import { useSeo } from "../lib/seo";
import { useBlock } from "../lib/content";
import { PageIntro } from "../components/PageIntro";

export const Route = createFileRoute("/testimonials")({
  component: TestimonialsPage,
});

function TestimonialsPage() {
  const t = useBlock("testimonials");
  const banners = useBlock("banners");

  useSeo({
    title: "Testimonials | Connect Sydney",
    description:
      "What Sydney Year 12 grads say about Connect — the friends they made, the talks that stuck, and how it set them up for their uni Christian group.",
    path: "/testimonials",
    image: banners.testimonialsImage,
  });
  return (
    <>
      <PageIntro
        eyebrow="From students"
        title="Testimonials"
        description={t.intro}
        image={banners.testimonialsImage}
        imageAlt={banners.testimonialsImageAlt}
      />

      <Section tone="paper" spacing="lg">
        {/* Masonry-ish: columns keep long and short quotes from leaving gaps. */}
        <div className="columns-1 gap-6 md:columns-2 lg:columns-3 [&>*]:mb-6 [&>*]:break-inside-avoid">
          {t.items.map((item, i) => (
            <blockquote
              key={i}
              className="rounded-card border border-secondary/30 bg-band p-6 shadow-soft"
            >
              <Quote className="h-6 w-6 text-secondary" aria-hidden />
              <p className="mt-3 leading-relaxed text-ink">{item.quote}</p>
              <footer className="mt-4">
                <p className="font-heading font-bold text-primary">— {item.name}</p>
                {item.detail && <p className="mt-0.5 text-sm text-muted">{item.detail}</p>}
              </footer>
            </blockquote>
          ))}
        </div>
      </Section>

      <Section tone="primary" spacing="md">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="font-heading text-2xl font-extrabold">{t.featuredName}</h2>
          <p className="mt-1 text-sm text-primary-fg/75">{t.featuredRole}</p>
          <p className="mt-5 text-lg leading-relaxed">“{t.featuredQuote}”</p>
          <div className="mt-8">
            <Button asChild variant="accent">
              <Link to="/sessions">Come along this season</Link>
            </Button>
          </div>
        </div>
      </Section>
    </>
  );
}
